import WooCommerce from "@/services/wooservice.js";
import { getCategoryTree } from "../../helpers/categoryTree";

const state = {
  categories: [],
};

const mutations = {
  setCategories(state, categories) {
    if (categories) {
      state.categories = categories;
    }
  },
};

const getters = {
  categories(state) {
    return state.categories;
  },

  categoryNames(state) {
    return state.categories.map((item) => {
      return item.name;
    });
  },

  categoryTree(state) {
    return getCategoryTree(state.categories);
  },
};

const actions = {
  async getCategories({ commit }) {
    const res = await WooCommerce.get("products/categories/", {
      per_page: 99,
    });

    commit("setCategories", res.data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  // getters
};
